module.exports = __webpack_public_path__ + "img/Karate-Fox-Logo-Template.jpg";